global.NPC_DATA = {
  ATK_SPEED: 14,
  ATK_DISTANCE: 26,
  // Row index into LIST_HITSOUND.STB for this monster's regular attack.
  ATTACK_SOUND: 28,
  HEIGHT: 42,
  TAB1: 21,
  TAB2: 22,
  TAB3: 23,
  SPECIALTAB: 24,
};

export class NpcStats {
  object: any;
  data: any;

  constructor(npcObj: any, charIdx: number) {
    this.object = npcObj;

    const npcList = GDM.getNow('list_npc');
    this.data = npcList.row(charIdx);
  }

  getAttackSpeed() {
    // LIST_NPC stores attack speed as a percentage (100 = normal speed).
    // NpcPawn divides by 100 when setting animation timeScale.
    return Number(this.data[NPC_DATA.ATK_SPEED]) || 100;
  }

  getAttackDistance() {
    return this.data[NPC_DATA.ATK_DISTANCE] / 100;
  }

  getAttackSound() {
    return Number(this.data[NPC_DATA.ATTACK_SOUND]) || 0;
  }

  getHeight() {
    if (!this.data[NPC_DATA.HEIGHT]) {
      return 0;
    } else {
      return parseInt(this.data[NPC_DATA.HEIGHT]) / 100;
    }
  }

  // LIST_NPC.STB columns 21-24 (World Server/startup.cpp:649-652): row
  // indices into LIST_SELL.STB for this NPC's up to 4 store tabs (0 = no
  // tab). See storedatamanager.ts for resolving a tab into its items.
  getStoreTabs() {
    return [
      Number(this.data[NPC_DATA.TAB1]) || 0,
      Number(this.data[NPC_DATA.TAB2]) || 0,
      Number(this.data[NPC_DATA.TAB3]) || 0,
      Number(this.data[NPC_DATA.SPECIALTAB]) || 0,
    ];
  }
}
